'use client';

import { CommonImage } from "@/components/common";
import { MapPin } from "lucide-react";
import Link from "next/link";

interface TProps {
    events: Array<{
        id: string | number;
        name: string;
        poster: string;
        eventAddress: string;
        link: string;
    }>;
}

const EventsSection = ({ events }: TProps) => {
    return (
        <section className='bg-white py-16 lg:py-24'>
            <div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8'>

                <div className='mx-auto mb-16 max-w-3xl text-center'>
                    <h2 className='text-3xl leading-11 font-extrabold text-gray-900 sm:text-4xl sm:leading-12 md:leading-16 lg:text-5xl'>
                        Captured Moments
                    </h2>
                    <p className='mt-2 text-base font-semibold text-gray-500'>
                        A glimpse into the unforgettable experiences powered by Greet. Real events, real people, real connections.
                    </p>
                </div>

                <div className='relative w-full overflow-hidden'>
                    <div className='animate-infinite-scroll flex w-max gap-8 hover:[animation-play-state:paused] py-8 px-4'>
                        {events?.map((item, index) => (
                            <Link
                                href={item?.link}
                                target='_blank'
                                rel='noreferrer'
                                key={index}
                                className='group relative flex h-auto w-80 md:w-[26rem] flex-col overflow-hidden rounded-3xl border border-gray-200 bg-slate-50 p-3 cursor-pointer transition-all duration-300 hover:border-gray-300'
                            >
                                <div className='relative h-40 sm:h-48 md:h-64 w-full overflow-hidden rounded-2xl bg-gray-200'>
                                    <CommonImage
                                        src={item?.poster}
                                        alt={item?.name}
                                        width={500}
                                        height={500}
                                        className='h-full w-full object-center transition-transform duration-700 group-hover:scale-110'
                                    />
                                </div>

                                <div className='mt-3 md:mt-4 mb-1 md:mb-2 px-1 md:px-2'>
                                    <div className='flex items-start justify-between gap-4'>
                                        <div className='w-full'>
                                            <h3 className='text-base md:text-lg font-bold text-gray-900 leading-tight group-hover:text-primary transition-colors duration-300 line-clamp-1'>
                                                {item?.name}
                                            </h3>
                                            {item?.eventAddress && (
                                                <div className='flex items-center gap-1 mt-1 text-gray-500 group-hover:text-gray-600'>
                                                    <MapPin className="w-3 h-3 flex-shrink-0" />
                                                    <span className='text-[10px] md:text-xs font-medium uppercase tracking-wide truncate'>
                                                        {item?.eventAddress}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>

            </div>
        </section>
    );
};

export default EventsSection;
